/// <amd-module name="VSSUI/Dialog" />
export { CornerDialog } from "./Components/Dialog/CornerDialog";
export { CustomDialog } from "./Components/Dialog/CustomDialog";
export { Dialog } from "./Components/Dialog/Dialog";

export { ICornerDialogProps, ICustomDialogProps, IDialogProps } from "VSSUI/Components/Dialog/Dialog.Props";
